const common = {
  nav: {
    getUmiGo: 'Obtener UmiGo',
    downloadTitle: 'Descargar UmiGo',
    apkDownload: 'Descarga APK',
    apkDesc: 'Instalación directa',
    googlePlay: 'Google Play',
    googlePlayDesc: 'Dispositivos Android',
    appStore: 'App Store',
    appStoreDesc: 'Dispositivos iOS',
  },
  hero: {
    title1: 'UmiGo',
    title2: 'Tu Mundo',
    title3: 'Social',
    subtitle: 'Chatea, juega y conéctate con tu familia en una sola app',
    watchDemo: 'Ver Demo',
  },
  features: {
    title: 'Todo lo que',
    titleLine2: 'necesitas',
    subtitle: 'Descubre las funciones que hacen de UmiGo tu app favorita',
    voiceChat: 'Chat de Voz',
    voiceChatDesc: 'Únete a salas de voz en tiempo real con calidad cristalina. Conéctate con amigos y familia en LATAM sin retrasos.',
    liveVideo: 'Video en Vivo',
    liveVideoDesc: 'Videollamadas cara a cara con hasta 12 personas simultáneamente',
    miniGames: 'Mini Juegos',
    miniGamesTag: '50+ juegos',
    miniGamesDesc: 'Juega con amigos en nuestra colección de divertidos mini juegos',
    familySpaces: 'Espacios Familiares',
    familySpacesDesc: 'Crea grupos familiares privados con calendarios, fotos y recuerdos compartidos',
    instantMessaging: 'Mensajería Instantánea',
    instantMessagingDesc: 'Envía texto, mensajes de voz, fotos y videos con cifrado de extremo a extremo',
    virtualGifts: 'Regalos Virtuales',
    virtualGiftsDesc: 'Envía divertidos regalos virtuales y stickers para expresarte en conversaciones',
  },
  about: {
    tag: 'Nuestra Comunidad',
    imageTitle1: 'Más que',
    imageTitle2: 'una app',
    imageTitle3: 'una familia',
    title: 'Conéctate con',
    titleLine2: 'quienes más importan',
    paragraph1: 'UmiGo nació de una idea simple: acercar a las familias y amigos latinoamericanos, sin importar la distancia. Entendemos la importancia de mantenerse conectado con tus seres queridos.',
    paragraph2: 'Nuestra plataforma combina lo mejor de las redes sociales, entretenimiento y herramientas de comunicación diseñadas específicamente para la comunidad LATAM. Desde chats de voz hasta mini juegos, cada función está diseñada para crear conexiones significativas.',
    paragraph3: 'Únete a millones de usuarios en América Latina que han hecho de UmiGo su hogar digital. Ya sea que estés poniéndote al día con la familia, jugando con amigos o conociendo gente nueva, UmiGo lo hace fácil y divertido.',
    joinButton: 'Únete a UmiGo',
  },
  testimonials: {
    tag: 'Testimonios',
    title: 'Lo que dicen',
    titleLine2: 'nuestros usuarios',
    user1: 'María Contreras',
    user1Since: 'Usuario desde 2024',
    user1Text: '¡UmiGo ha cambiado completamente cómo me mantengo en contacto con mi familia en México. La calidad del chat de voz es increíble, y a mis hijos les encantan los mini juegos!',
    user2: 'Juan Silva',
    user2Since: 'Usuario desde 2023',
    user2Text: '¡La mejor app social para América Latina! He hecho muchos amigos de diferentes países. La función de espacios familiares es perfecta para organizar reuniones.',
    user3: 'Ana Rodríguez',
    user3Location: 'Buenos Aires, Argentina',
    user4: 'Carlos Mendoza',
    user4Location: 'Lima, Perú',
    user4Text: '¡Uso UmiGo todos los días para conectarme con mi equipo de juegos. La calidad de video es increíble y nunca experimentamos retrasos!',
    user5: 'Laura Gómez',
    user5Text: '¡Perfecto para mantenerse conectado con la familia a través de fronteras. Me encanta!',
    user6: 'Diego Pérez',
    user6Text: '¡Los mini juegos son tan adictivos! Toda mi familia juega junta cada fin de semana.',
  },
  cta: {
    tag: 'Disponible Ahora',
    imageTitle1: 'Descarga',
    imageTitle2: 'UmiGo',
    imageTitle3: 'Hoy',
    title: 'Comienza tu',
    titleLine2: 'aventura social',
    description: '¡Únete a millones de usuarios en toda América Latina! Descarga UmiGo ahora y comienza a conectarte con amigos y familiares en segundos. ¡Es gratis, rápido y divertido!',
    downloadButton: '¡Obtén UmiGo!',
  },
  footer: {
    title: 'Mantente',
    titleLine2: 'Conectado',
    subtitle: 'Conéctate con nosotros directamente si eres influencer, socio potencial o diriges una agencia',
    emailPlaceholder: 'tu@email.com',
    subscribeButton: 'Conectar',
    subscribing: 'Conectando...',
    successMessage: '¡Conectado exitosamente!',
    errorMessage: 'Algo salió mal. Por favor, inténtalo de nuevo.',
    linksTitle: 'Enlaces',
    features: 'Funciones',
    games: 'Juegos',
    family: 'Familia',
    download: 'Descargar',
    contactTitle: 'Contacto',
    officeTitle: 'Oficina',
    officeAddress: 'Av. Paseo de la Reforma 222\nCiudad de México, CDMX 06600\nMéxico',
    privacy: 'Privacidad',
    terms: 'Términos',
    copyright: '© 2025 UmiGo. Todos los derechos reservados.',
  },
};

export default common;
